import React from 'react'
import { Button, CircularProgress } from '@mui/material'

const ButtonWithIcon = ({
  variant,
  startIcon,
  endIcon,
  disabled,
  margin,
  sx,
  onClick,
  buttonType,
  buttontype,
  isLoading,
  loading,
  loadingposition,
  text,
  ...rest
}) => {
  const showLoading = Boolean(isLoading || loading)

  return (
    <Button
      variant={variant}
      startIcon={!showLoading ? startIcon : null}
      endIcon={!showLoading ? endIcon : null}
      disabled={disabled}
      sx={{
        color: '#242424',
        borderColor: '#242424',
        margin: `${margin ? margin : '0px'}`,
        '&:hover': {
          backgroundColor: '#242424',
          borderColor: '#242424',
          boxShadow: 'none',
          color: '#fff',
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: '#fff',
          borderColor: '#242424',
          color: '#246434',
        },
        '&:focus': {
          borderColor: '#242424',
        },
        ...sx,
      }}
      onClick={onClick}
      type={buttonType || buttontype}
      {...rest}
    >
      {showLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : text}
    </Button>
  )
}

export default ButtonWithIcon